const base = {
  noOptions: "No Options"
};
function getDefaultTexts(texts) {
  return {
    noOptions: texts?.noOptions ?? base.noOptions
  };
}
export {
  getDefaultTexts
};
//# sourceMappingURL=getDefaultTexts.js.map
